import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './card.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import {AnimationService, AnimatorModule} from 'css-animator';
import { IgxCheckboxModule, IgxDropDownModule, IgxIconModule, IgxToggleModule } from 'igniteui-angular';
import { SharedModule } from '../../shared.module';
import { HamburgerMenuComponent } from './hamburger-menu/hamburger-menu.component';

@NgModule({
  imports: [
    CommonModule,
    NgbDropdownModule,
    AnimatorModule,
    IgxCheckboxModule,
    IgxDropDownModule,
    IgxIconModule,
    IgxToggleModule
  ],
  declarations: [CardComponent, HamburgerMenuComponent],
  exports: [CardComponent],
  providers: [AnimationService]
})
export class CardModule { }
